import {Directive, HostBinding, HostListener, Input} from '@angular/core';
import {MediaPreviewService} from './media-preview.service';

@Directive({
    selector: '[youTubePreview]',
    standalone: false
})
export class YouTubePreviewDirective {
  @Input() youTubePreview: string;
  @HostBinding('style.cursor') cursor = 'pointer';

  constructor(
      private readonly mediaPreviewService: MediaPreviewService,
  ) {}

  @HostListener('click')
  clickHandler() {
    this.mediaPreviewService.previewYouTube(this.youTubePreview);
  }
}
